declare var unlayer;
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Ladder } from 'src/models/ladder.model';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'admin-email',
  templateUrl: './email.component.html',
  styleUrls: ['email.component.scss']
})
export class AdminEmailComponent implements OnInit {
  public unlayerEditor: any;
  public busy: boolean = false;
  public busySend: boolean = false;
  public playerlist: Player[] = [];
  public ladders: Ladder[] = [];
  public ladderId: string = "";
  public msg: string;
  public form: FormGroup;
  public subject: string = "Boca Tennis Ladder - Rules";
  public bodytext: string = `
  <div style="text-align:center">
  <img height="100" src="https://www.BocaTennisLadder.com/images/t2.png">
  <br />
  <div style="font-weight: bold; font-size: 12pt;">Boca Raton Tennis Ladder</div>
  <div style="font-size: 9pt;"><a href="https://www.bocatennisladder.com">www.bocatennisladder.com</a></div>
  </div>
  <div>
  <p>Hi {firstname},</p>
  <p>We are in week {weeknumber} of the {ladderid} tennis ladder.  You have completed {matchcount} so far on 
  level {levelid}.</p>
  <p>{additionalmessage}</p>
  <p>Cheers,<br />Eric</p>
  </div>`;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private elementRef: ElementRef,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private routerLink: Router) {
    this.busy = false;
    this.form = fb.group(
      {
        ladderId: new FormControl('', [Validators.required]),
        subject: new FormControl('Tennis Ladder Update', [Validators.required]),
        //body: new FormControl(this.bodytext, [Validators.required]),
        players: fb.array([])
      }
    );
    this.form.controls['ladderId'].valueChanges.subscribe(
      (resp) => {
        if (resp != '')
          this.fetchPlayers(resp)
      },
      (err) => { }
    )
  }

  get players() {
    return this.form.get('players') as FormArray;
  }
  // addAlias() {
  //   this.players.push(this.fb.group({
  //     id: new FormControl()
  //   }));
  // }

  ngOnInit(): void {
    this.http.get<Ladder[]>('/ladders').subscribe(
      (resp) => {
        this.ladders.length = 0;
        for (const l of resp) {
          this.ladders.push(new Ladder(l));
        }
      }
    )
  }

  // unlayer id: tennis&#64;elubin.com
  public isLoading: boolean = true;
  ngAfterViewInit() {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "https://editor.unlayer.com/embed.js";
    this.elementRef.nativeElement.appendChild(s);

    setTimeout(() => {
      // lol dexSPXBsGAeTsnhZYO8w90NKaNrhkCpsEPYxAHOHtwa2joocxLXgBYiJYm4nWKvN
      // tennis QGzOmeZpXrzRq3Mqw3UjN2QjgiZkQRII7ZUySAhb6dVd6A1RYsu2TPzPj4gejuaD
      this.unlayerEditor = unlayer.createEditor({
        id: 'editor',
        projectId: 193582,
        templateId: "423954",
        displayMode: 'email'
      })
      this.isLoading = false;
    }, 2000);
  }

  // https://docs.unlayer.com/docs/templates
  public loadTemplate(evt: any, id: string, subject: string = '') {
    this.unlayerEditor.loadTemplate(id);
    this.form.controls.subject.setValue(subject);
  }

  public unpaid(evt: any) {
    for (let x of this.players.controls) {
      let y = x as FormGroup;
      if (y.controls['paid'].value == 0 && y.controls['levelId'].value > 1)
        y.controls['selected'].setValue(true);
      else
        y.controls['selected'].setValue(false);
    }
  }
  public allOff(evt: any) {
    for (let x of this.players.controls) {
      let y = x as FormGroup;
      y.controls['selected'].setValue(false);
    }
  }
  public zeroOn(evt: any) {
    for (let x of this.players.controls) {
      let y = x as FormGroup;
      if (y.controls['matchCount'].value == 0)
        y.controls['selected'].setValue(true);
      else
        y.controls['selected'].setValue(false);
    }
  }

  public fetchPlayers(value: string) {
    this.http.get<Player[]>(`/admin/getallplayers/${value}?includeMatchCount=true`).subscribe(
      (resp: Player[]) => {
        console.log(resp);
        // clear the form
        this.players.clear();

        this.playerlist.length = 0;
        for (let p of resp) {
          this.playerlist.push(new Player(p));
          this.players.push(
            this.fb.group(
              {
                selected: new FormControl(p.levelId > 1),
                id: new FormControl(p.id),
                levelId: new FormControl(p.levelId),
                matchCount: new FormControl(p.matchCount),
                paid: p.paid
              }
            )
          )
        }
      }
    );
  }

  public submit(evt: any) {
    // get all the data on the form
    let data = JSON.parse(JSON.stringify(this.form.value));
    // now filter down to only the selected players, and remove the unneccesary data
    data.players = data.players
      .filter(f => f.selected == true)
      .map(f => ({ id: f.id, levelId: f.levelId }));
    this.busySend = true;
    this.unlayerEditor.exportHtml((unilayerdata) => {
      data.body = unilayerdata.html;

      this.http.post('/admin/sendemail', data).subscribe(
        (resp: any) => { this.busySend = false; console.log(resp); alert(resp.success); },
        (err) => { alert(JSON.stringify(err)); this.busySend = false; }
      )
    });
  }
}
